import React, { Component } from 'react';
import styled from 'styled-components';

const LabelStyled = styled.label`
  display: block;
  padding: 10px 5px 0px 5px;
  margin: 10px auto;
  border: none;
  width: 100%;
  outline: none;
  font-size: 14px !important;
  font-family: 'Open Sans', sans-serif !important;
`;

export const InputLabel: React.FC<any> = props => {
  return <LabelStyled {...props}>{props.children}</LabelStyled>;
};

export default InputLabel;
